import buttonLinkTpl from './base';

const buttonLinkSoftTpl = (data = {}) => {
    return buttonLinkTpl({...data, cls: data.cls || 'ck-button-link-soft'});
}
export { buttonLinkTpl, buttonLinkSoftTpl }